import React from 'react'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import './Toast.scss'
import { connect } from 'react-redux'
import { clearErrorToast, clearSuccessToast } from '../../actions'

class Toast extends React.Component {
  constructor(props) {
    super()
    this.closeToastRef = React.createRef(null)
    this.state = {
      animationClass: 'float-in-up',
      exiting: false,
      message: props.message,
      visible: props.message ? true : false,
    }
    this.timer = null
  }
  componentDidMount = () => {
    if (this.state.visible) {
      this.startTimer()
      if (this.closeToastRef.current !== null) {
        this.closeToastRef.current.focus()
      }
    }
    window.addEventListener('keydown', this.escapeListener)
  }
  componentWillUnmount = () => {
    window.removeEventListener('keydown', this.escapeListener)
  }
  componentDidUpdate = (prevProps) => {
    if (!prevProps.manual && this.props.message !== this.state.message) {
      this.setState({
        message: this.props.message,
        animationClass: 'float-in-up',
        visible: true,
      })
      this.startTimer()
      if (this.closeToastRef.current !== null) {
        this.closeToastRef.current.focus()
      }
    }
  }
  startTimer = () => {
    this.cancelTimer()
    this.timer = window.setTimeout(this.startExiting, this.props.timeout || 5000)
  }
  cancelTimer = () => {
    window.clearTimeout(this.timer)
  }
  escapeListener = (e) => {
    if (this.state.visible && e.key === 'Escape') {
      this.startExiting()
    }
  }
  startExiting = () => {
    if (this.props.message) {
      this.setState({
        animationClass: 'float-out-down',
        exiting: true,
      })
    }
    this.cancelTimer()
  }
  dismiss = () => {
    if (this.state.exiting === true) {
      this.setState({
        visible: false,
        exiting: false,
        message: null,
      })
      this.cancelTimer()
      this.props.danger && this.props.clearErrorToast()
      this.props.success && this.props.clearSuccessToast()
    }
  }
  trigger = () => {
    this.cancelTimer()
    this.setState({
      message: this.props.message,
      animationClass: 'float-in-up',
      visible: true,
      exiting: false,
    })
    this.startTimer()
  }
  render() {
    const { message, danger, success } = this.props
    return this.state.visible && message ? (
      <div
        className={
          `toast-wrapper  ${this.state.animationClass}` +
          (this.props.isSidebarCollapsed ? ' sidebar-collapsed ' : ' ')
        }
        onAnimationEnd={this.dismiss}
      >
        <div
          className={`toast ${success ? 'success' : ''} ${danger ? 'danger' : ''}`}
          onMouseEnter={this.cancelTimer}
          onMouseLeave={this.startTimer}
        >
          <span
            className="message"
            role="alert"
            aria-label={message}
            dangerouslySetInnerHTML={{ __html: message }}
          ></span>
          <button
            className="dismiss-btn"
            onClick={this.startExiting}
            aria-label="Close toast"
            ref={this.closeToastRef}
          >
            <CrossIcon />
          </button>
        </div>
      </div>
    ) : null
  }
}
export default connect(
  (state) => ({
    isSidebarCollapsed: state.app.sidebarCollapsed,
  }),
  { clearErrorToast, clearSuccessToast }
)(Toast)
